import {DataFetcher} from '@aboutyou/data-fetcher';
import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import {useGetBrowseUsps} from '../BrowsePage/Usps/useGetBrowseUsps';
import {USP_BANNER_HEIGHT} from '../Header/constants';
import {UspBannerView} from './UspBannerView';

export const UspBanner: React.FC = () => (
  <DataFetcher
    // TODO: this will be moved to its own, new endpoint https://aboutyou.atlassian.net/browse/ASFE-11764
    request={useGetBrowseUsps()}
    Loading={Skeleton}
    View={UspBannerView}
    Error={() => null}
  />
);

const Skeleton = () => {
  return <SkeletonBlock $height={`${USP_BANNER_HEIGHT}px`} />;
};
